import { UserDaily } from "../model/statistic/Daily";
import {
    GetDailyRsp,
    GetMonthActivityRsp,
    SignInRsp,
} from "../model/statistic/summary/summary_data";
import { LogDebug } from "../tools/log";
import { requestBackend } from "./common";

interface GetDailyProps {
    afterSuccess: (d: UserDaily) => void;
    dispatch: any;
}

export function GetDaily(props: GetDailyProps) {
    const { dispatch, afterSuccess } = props;
    return requestBackend({
        uri: `/api/summary/get_daily`,
        req_data: {},
        handleRsp: (rsp_json: any) => {
            let rsp = new GetDailyRsp();
            Object.assign(rsp, rsp_json);
            LogDebug("GetDailyRsp", rsp);
            afterSuccess(rsp.user_daily);
            return rsp;
        },
        errTitle: "获取日活数据失败",
        dispatch,
    });
}

interface GetMonthActivityProps {
    year: number;
    month: number;
    afterSuccess: (days: number[]) => void;
    dispatch: any;
}

export function GetMonthActivity(props: GetMonthActivityProps) {
    const { dispatch, afterSuccess, year, month } = props;
    requestBackend({
        uri: `/api/summary/month_activity`,
        req_data: {
            year: year,
            month: month,
        },
        handleRsp: (rsp_json: any) => {
            let rsp = new GetMonthActivityRsp();
            Object.assign(rsp, rsp_json);
            LogDebug("GetMonthActivityRsp", rsp);
            afterSuccess(rsp.days);
            return rsp;
        },
        errTitle: "获取用户打卡数据失败",
        dispatch,
    });
}

interface SignInProps {
    afterSuccess: (d: UserDaily, days: number[]) => void;
    dispatch: any;
}

export function SignIn(props: SignInProps) {
    const { dispatch, afterSuccess } = props;
    return requestBackend({
        uri: `/api/summary/sign_in`,
        req_data: {},
        handleRsp: (rsp_json: any) => {
            let rsp = new SignInRsp();
            Object.assign(rsp, rsp_json);
            LogDebug("SignInRsp", rsp);
            afterSuccess(rsp.user_daily, rsp.calendar_days);
            return rsp;
        },
        errTitle: "签到失败",
        dispatch,
    });
}
